import { FormEvent, useCallback } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { propertyNavigateOptions, PropertyRouteTo } from '@/routes.ts';

export const useDashboardAskHandoff = (
	propertyPublicId: string | undefined,
	value: string,
	setValue: (value: string) => void,
) => {
	const navigate = useNavigate();

	return useCallback(
		(event: FormEvent): Promise<void> => {
			event.preventDefault();
			const trimmed = value.trim();
			if (!trimmed || !propertyPublicId) return Promise.resolve();

			setValue('');
			navigate(propertyNavigateOptions(propertyPublicId, PropertyRouteTo.dashboard, { q: trimmed }));
			return Promise.resolve();
		},
		[navigate, propertyPublicId, setValue, value],
	);
};
